module.exports = __webpack_public_path__ + "svgs/icon_address.aff2831b.svg";